export default "__VITE_ASSET__CNDSo1nA__"